import styled, { css, keyframes } from 'styled-components';

import { fadeIn } from 'utils/style/animations';

export const popIn = keyframes`
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
  100% {
    transform: scale(1);
  }
`;

export const PullToRefreshContainer = styled.div<{ isRefreshing: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  height: 100px;
  div[aria-label='animation'] {
    height: 100%;
  }
  p {
    margin-bottom: 0.25rem;
  }
  ${p =>
    p.isRefreshing &&
    css`
      div[aria-label='animation'] {
        opacity: 0;
        animation: ${fadeIn} 0.25s forwards;
      }
    `}
`;

export const ReleaseMessage = styled.p`
  animation: ${popIn} 0.25s forwards;
  font-weight: ${Styles.fontWeight.heavy};
`;

export const PullDownMessage = styled.p`
  font-weight: ${Styles.fontWeight.heavy};
`;
